export const CURRENT_PAGE_DEFAULT = 1;

export const CURRENT_LIST_USER_MAP = 8;

export const SIZE_PAGE_RESPONSES = 8;
export const SIZE_PAGE_RECENT_POST = 5;
export const SIZE_PAGE_UPLOAD_VIDEO = 8;

export const SIZE_CLIENTS_PAGE = 20;
export const SIZE_LOCATIONS_PAGE = 20;

export const SIZE_DOCUMENTATION_PAGE = 10;
export const SIZE_USER_PAGE = 1000;
export const SIZE_VALIDATION_ASSET_MODEL = 10;
export const SIZE_PAGE_REPORT = 10;
export const SIZE_PDF_MAPPING = 10;
